<template>
  <div class="warninglogin">
    <a-layout id="components-layout-demo-top" class="layout">
      <headerComponent :showNormal="true"></headerComponent>
      <a-layout-content>
      <div class="headerContent">
        <a-breadcrumb class="bgCrumb">
            <a-breadcrumb-item>
              <a @click="qxreturn">
                方案列表
              </a>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                新建预警
            </a-breadcrumb-item>
          <!-- <a-breadcrumb-item>List</a-breadcrumb-item>
          <a-breadcrumb-item>App</a-breadcrumb-item> -->
        </a-breadcrumb>
        <div class="tip">新建预警</div>
      </div>
     
        <div class="dataContent">
      <a-card>
      <div
        class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        基本设置
      </div>
      <a-form  layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-form-item
          label="预警名称"
          style="margin-left: 0px; margin-top: -30px"
          class="form-margin"
        >
          <a-row>
            <a-col :span="18">
              <a-input
                placeholder="请输入预警名称"
                style="width: 250px"
                v-model:value="YJname"
              ></a-input>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="预警频率"
          style="margin-left: 0px"
          class="form-margin"
        >
          <a-select
            v-model:value="times"
            style="width: 180px"
            ref="select"
            placeholder="请选择频率"
          >
            <a-select-option value="10">每10分钟</a-select-option>
            <a-select-option value="20">每20分钟</a-select-option>
            <a-select-option value="60">每1小时</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="接收时段"
          style="margin-left: 0px"
        > 
          <a-select
            v-model:value="receiveDay"
            style="width: 180px"
            ref="select"
            placeholder="按自然日"
          >
            <a-select-option value="2,3,4,5,6,7,1">按自然日</a-select-option>
            <a-select-option value="2,3,4,5,6">按工作日</a-select-option>
          </a-select>
           <a-span style="margin-left:5%"> 开始时间：</a-span>
          <a-time-picker
            format="HH:mm" 
            v-model:value="receiveTimeStart"
            v-model:open="open"
            @openChange="handleOpenChange"
            placeholder="选择开始时间"
          >
            <template #addon>
              <a-button size="small" type="primary" @click="handleClose"
                >确定
              </a-button>
            </template>
          </a-time-picker>
          <a-span style="margin-left:5%"> 结束时间：</a-span>
          <a-time-picker  format="HH:mm"  v-model:value="receiveTimeEnd" v-model:open="open2" placeholder="选择结束时间">
            <template #addon>
              <a-button size="small" type="primary" @click="handleClose"
                >确定</a-button
              >
            </template>
          </a-time-picker>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card>
      <div
       class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        条件设置
      </div>
      <a-form layout="inline" class="form-class">
        <a-form-item  class="form-margin">
          <!-- 多选框 -->
          <a-span class="font-size: 14px">目标平台 </a-span>
          <div>
            <a-checkbox
              v-model:checked="state.checkAll"
              :indeterminate="state.indeterminate"
              @change="onCheckAllChange"
              >全选
            </a-checkbox>
            <a-checkbox-group
              v-model:value="state.checkedList"
              :options="plainOptions"
            />
          </div>
          <!-- 文本域 -->
          <a-span style="margin-right: 600px; font-size: 14px"
            >目标关键词
          </a-span>
          <a-textarea
            auto-size
            v-model:value="keyword"
            placeholder="请输入关键词用','分割"
            :rows="2"
            @change="getArr"
            @blur="switchVal1"
            style="width: 40%; margin-right: 280px"
          />
          <br />
          <a-select
            mode="multiple"
            :open="false"
            v-model:value="selectValue"
            @change="handleChange1"
            style="width: 40%"
          >
          <a-select-option v-for="(i,index) in selectArr" :key='index'>
            {{i}}
          </a-select-option>
          </a-select>
           <br />
          <a-span style="margin-right: 610px; font-size: 14px"
            >当前词数:{{ keywordCount }}
          </a-span>
          <br />
          <!-- 数字输入框1 -->
          <a-span style="margin-right: 530px; font-size: 14px"
            >按目标关键词的相关声量
            <a-tooltip>
              <template #title>
                每个目标关键词大于或等于您的设定值的信息会以邮件形式进行预警。 
              </template>
              <QuestionCircleOutlined />
            </a-tooltip>
          </a-span>
          <div style="margin-right: 535px">
            <a-span>数量</a-span>
            &nbsp;
            <a-input-number
              v-model:value="kwCount"
              :max="10"
              :min="1"
              placeholder="请输入"
            />
          </div>
          <!-- 数字输入框2 -->
          <a-span style="margin-right: 500px; font-size: 14px"
            >与品牌词精准字距设置
            <a-tooltip>
              <template #title>
                每个目标关键词与品牌词之间的字距小于您的设定值的信息会以邮件形式进行预警。
              </template>
              <QuestionCircleOutlined />
            </a-tooltip>
            <!-- 开关 -->
            <a-switch
              checked-children="开"
              un-checked-children="关"
              v-model:checked="kwBrandOpen"
            />
          </a-span>

          <div v-show="kwBrandOpen" style="margin-right: 535px">
            <a-span>数量</a-span>
            &nbsp;
            <a-input-number
              v-model:value="kwBrandCount"
              :max="10"
              :min="1"
              placeholder="请输入"
            />
          </div>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card>
      <div
       class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        接收设置
      </div>
      <a-form layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-table
          :pagination="false"
           bordered
          :data-source="dataSource"
          :columns="columns"
          :loading="loading"
        >
          <!-- <template #name="{ text, record }">
            <div class="editable-cell">
              <div
                v-if="editableData[record.key]"
                class="editable-cell-input-wrapper"
              >
                <a-input
                  v-model:value="editableData[record.key].name"
                  @pressEnter="save(record.key)"
                />
                <check-outlined
                  class="editable-cell-icon-check"
                  @click="save(record.key)"
                />
              </div>
              <div v-else class="editable-cell-text-wrapper">
                {{ text || " " }}
                <edit-outlined
                  class="editable-cell-icon"
                  @click="edit(record.key)"
                />
              </div>
            </div>
          </template> -->
             <template #email="{ text, record }">
            <div class="editable-cell">
              <div
                v-if="editableData[record.key]"
                class="editable-cell-input-wrapper"
              >
                <a-input
                  v-if="editableData[record.key]"
                  placeholder="请输入邮箱"
                  @pressEnter="save(record.key)"
                  v-model:value="editableData[record.key]['email']"
                  style="margin: -5px 0"
                />
                <template v-else>
                  {{ text }}
                </template>
                <!-- <a-form  :model="editableData[record.key]"  ref="formRef" :rules="rules">
                    <a-form-item name="email">
                      <a-input
                          v-model:value="editableData[record.key].email"
                          @pressEnter="save(record.key)"
                        />
                    </a-form-item>
                  
                    <check-outlined
                      class="editable-cell-icon-check"
                      @click="save(record.key)"
                    />
                  </a-form> -->
              </div>
              <div v-else class="editable-cell-text-wrapper">
                {{ text || " " }}
                <!-- <edit-outlined
                  class="editable-cell-icon"
                  @click="edit(record.key)"
                /> -->
              </div>
            </div>
          </template>
          <!-- <template v-for="col in ['email']" #[col]="{ text, record }" :key="col">
      <div>
        <a-input
          v-if="editableData[record.key]"
          v-model:value="editableData[record.key][col]"
          style="margin: -5px 0"
        />
        <template v-else>
          {{ text }}
        </template>
      </div>
    </template> -->
    <template #operation="{ record }">
      <div class="editable-row-operations">
        <span>
         
        </span>
        <span v-if="editableData[record.key]">
          <a @click="save(record.key)">保存</a>
          <a @click="cancel(record.key)" style="margin: 0px 5px">取消</a>
        </span>
        <span v-else>
          <a  @click="edit(record.key)">编辑</a>
        </span>
        <a-popconfirm
          v-if="dataSource.length"
          title="确定删除?"
          @confirm="onDelete(record.key)"
        >
          <a   v-if="!editableData[record.key]" style="margin: 0px 5px">删除</a>
        </a-popconfirm>
      </div>
    </template>
          <!-- <template #operation="{ record }">
            <a-popconfirm
              v-if="dataSource.length"
              title="确定删除?"
              @confirm="onDelete(record.key)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template> -->
        </a-table>
        <br />
        <a-button
          class="editable-add-btn"
          @click="handleAdd"
          style="margin-bottom: 8px"
          >+新增收件人</a-button
        >
      </a-form>
    </a-card>
        </div>
        <a-layout-footer style="text-align: center">
          <!-- Copy Right ©2021 -->
              <div class="hoverBottomWapper"> 
      <div  class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
      </div>
    </div>
   
        </a-layout-footer>
      </a-layout-content>
    </a-layout>
    <!-- <div class="title">
      <img class="image-class" src="../../assets/u13.png" />
      <div>
        <div
          style="
            width: 46px;
            height: 46px;
            background: #aaa;
            margin: auto 0;
            border: 1px solid #aaa;
            border-radius: 50%;
          "
        ></div>
        <span>Jay.Liu</span>
      </div>
    </div> -->
    <!-- <headerComponent></headerComponent>
    <div>
      <a-card style="line-height: 2">
        <a-row style="margin: auto 240px">
          <a-col>
            <a-span><span @click="returnsy" class="cur">首页/</span>  新建预警</a-span>
            <a-col><a-span style="font-size: 26px">新建预警</a-span></a-col>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <br /> -->
    <!-- <a-card style="width: 66%; margin: 0 auto">
      <div
        class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        基本设置
      </div>
      <a-form  layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-form-item
          label="预警名称"
          style="margin-left: 0px; margin-top: -30px"
          class="form-margin"
        >
          <a-row>
            <a-col :span="18">
              <a-input
                placeholder="请输入预警名称"
                style="width: 250px"
                v-model:value="YJname"
              ></a-input>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="预警频率"
          style="margin-left: 0px"
          class="form-margin"
        >
          <a-select
            v-model:value="times"
            style="width: 180px"
            ref="select"
            placeholder="请选择频率"
          >
            <a-select-option value="10">每十分钟</a-select-option>
            <a-select-option value="20">每二十分钟</a-select-option>
            <a-select-option value="60">每1小时</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="接收时段"
          style="margin-left: 0px"
          class="form-margin"
        > 
          <a-select
            v-model:value="receiveDay"
            style="width: 180px"
            ref="select"
            placeholder="按自然日"
          >
            <a-select-option value="2,3,4,5,6,7,1">按自然日</a-select-option>
            <a-select-option value="2,3,4,5,6">按工作日</a-select-option>
          </a-select>
           <a-span style="margin-left:10px"> 开始时间</a-span>
          <a-time-picker
            format="HH:mm" 
            v-model:value="receiveTimeStart"
            v-model:open="open"
            @openChange="handleOpenChange"
            placeholder="选择开始时间"
          >
            <template #addon>
              <a-button size="small" type="primary" @click="handleClose"
                >确定
              </a-button>
            </template>
          </a-time-picker>
          &nbsp;

          <a-span> 结束时间</a-span>
          &nbsp;
          <a-time-picker  format="HH:mm"  v-model:value="receiveTimeEnd" v-model:open="open2" placeholder="选择结束时间">
            <template #addon>
              <a-button size="small" type="primary" @click="handleClose"
                >确定</a-button
              >
            </template>
          </a-time-picker>
        </a-form-item>
      </a-form>
    </a-card>
    <br /> -->
    <!-- <a-card style="width: 66%; margin: 0 auto">
      <div
       class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        条件设置
      </div>
      <a-form layout="inline" class="form-class">
        <a-form-item  class="form-margin">
          <a-span class="font-size: 14px">目标平台 </a-span>
          <div>
            <a-checkbox
              v-model:checked="state.checkAll"
              :indeterminate="state.indeterminate"
              @change="onCheckAllChange"
              >全选
            </a-checkbox>
            <a-checkbox-group
              v-model:value="state.checkedList"
              :options="plainOptions"
            />
          </div>
          <a-span style="margin-right: 600px; font-size: 14px"
            >目标关键词
          </a-span>
          <a-textarea
            v-model:value="keyword"
            placeholder="请输入关键词用‘，’分割"
            :rows="2"
            @change="getArr"
            style="width: 40%; margin-right: 280px"
          />
          <br />
          <a-select
            mode="multiple"
            v-model:value="selectValue"
            @change="handleChange1"
            style="width: 200px"
          >
          <a-select-option v-for="(i,index) in selectArr" :key='index'>
            {{i}}
          </a-select-option>
          </a-select>
           <br />
          <a-span style="margin-right: 610px; font-size: 14px"
            >当前词数:{{ keywordCount }}
          </a-span>
          <br />
          <a-span style="margin-right: 530px; font-size: 14px"
            >按目标关键词的相关声量
          </a-span>
          <div style="margin-right: 535px">
            <a-span>数量</a-span>
            &nbsp;
            <a-input-number
              v-model:value="kwCount"
              :max="10"
              :min="1"
              placeholder="请输入"
            />
          </div>
          <a-span style="margin-right: 500px; font-size: 14px"
            >与品牌词精准字距设置
            <a-switch
              checked-children="开"
              un-checked-children="关"
              v-model:checked="kwBrandOpen"
            />
          </a-span>

          <div v-show="kwBrandOpen" style="margin-right: 535px">
            <a-span>数量</a-span>
            &nbsp;
            <a-input-number
              v-model:value="kwBrandCount"
              :max="10"
              :min="1"
              placeholder="请输入"
            />
          </div>
        </a-form-item>
      </a-form>
    </a-card> -->
    <!-- <br /> -->
    <!-- <a-card style="width: 66%;  margin: 0 auto 0px auto">
      <div
       class="seting"
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        "
      >
        接收设置
      </div>
      <a-form layout="inline" class="form-class">
        <a-form-item  class="form-margin">
        </a-form-item>
        <a-table
          :pagination="false"
           bordered
          :data-source="dataSource"
          :columns="columns"
        >
             <template #age="{ text, record }">
            <div class="editable-cell">
              <div
                v-if="editableData[record.key]"
                class="editable-cell-input-wrapper"
              >
                <a-input
                  v-model:value="editableData[record.key].age"
                  @pressEnter="save(record.key)"
                />
                <check-outlined
                  class="editable-cell-icon-check"
                  @click="save(record.key)"
                />
              </div>
              <div v-else class="editable-cell-text-wrapper">
                {{ text || " " }}
                <edit-outlined
                  class="editable-cell-icon"
                  @click="edit(record.key)"
                />
              </div>
            </div>
          </template>
          <template #operation="{ record }">
            <a-popconfirm
              v-if="dataSource.length"
              title="确定删除?"
              @confirm="onDelete(record.key)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <br />
        <a-button
          class="editable-add-btn"
          @click="handleAdd"
          style="margin-bottom: 8px"
          >+新增收件人</a-button
        >
      </a-form>
    </a-card>
        <a-layout-footer></a-layout-footer> -->
    <div style="width: 100%">
      <a-card style="margin-bottom:0">
        <a-row style="margin-left:80%;">
          <a-col style="checked: ref(false)">
            <a-button @click="qxreturn">取消</a-button>
          </a-col>
          &nbsp;&nbsp;&nbsp;
          <a-col>
            <a-button @click="onCreateYJ" :loading="loadingBtn" type="primary"> 提交 </a-button>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <!-- <div style="width:320px;margin:0 auto; padding:20px 0;">
    </div> -->
  </div>
</template>

<script>
import { addyj,getUserInfo,getPlat} from "../../utils/api";
import { message,Modal } from "ant-design-vue";
import { createVNode } from 'vue';
import { CheckOutlined, EditOutlined,QuestionCircleOutlined } from "@ant-design/icons-vue";
import { cloneDeep } from "lodash-es";
import headerComponent from '../../components/header'
const checkAge = function(rule,val){
  if(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)){
    return Promise.resolve();
  }else{
    return Promise.reject('邮箱格式不正确');
  }
}
export default {
  components: {
    CheckOutlined,
    EditOutlined,
    headerComponent,
    QuestionCircleOutlined
  },
  data(){
    return{
      times:'',
      YJname:'',
      userId:'',
      loadingBtn:false,
      rules :{
      email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        { validator: checkAge, message: '邮箱格式不正确', trigger: 'blur' },
      ]
      },
      loading:false,
      receiveDay:'',
      open:false,
      open2:false,
      editableData:{},
      columns:[
      {
        title: "序号",
        dataIndex: "name",
        key:'name',
        width: "30%",
        slots: {
          customRender: "name",
        },
      },
      {
        title: "邮箱",
        dataIndex: "email",
         key:'email',
         slots: {
          customRender: "email",
        },
      },
      {
        title: "操作",
        dataIndex: "operation",
        slots: {
          customRender: "operation",
        },
      },
    ],
      plainOptions : [
        // "微博",
        // "论坛",
        // "微信",
        // "新闻",
        // "电商评论",
        // "电商内容",
        // "短视频",
        // "综合视频",
        // "问答",
      ],
      dataSource:[  {
        name: 1,
        key:1,
        email: "",
      }],
      receiveTimeStart:'',
      receiveTimeEnd:'',
      selectValue:[],
      keywordCount:0,
      keyword:'',
      kwBrandOpen:false,
      kwCount:1,
      plainOptions1:[ 
        // {code:"mobile_weibo",name:"微博"},
        // {code:"mobile_bbs",name:"论坛"},
        // {code:"mobile_wechat",name:"微信"},
        // {code:"mobile_news",name:"新闻"},
        // {code:"mobile_svideo",name:"短视频"},
        // {code:"mobile_eccm",name:"电商评论"},
        // {code:"mobile_eccn",name:"电商内容"},
        // {code:"mobile_video",name:"综合视频"},
        // {code:"mobile_wenda",name:"问答"}
      ],
      state:{
        indeterminate: true,
        checkAll: false,
        checkedList: [],
      },
      kwBrandCount:1,
      selectArr:[]
    }
  },
  watch:{
    selectValue(newVal,oldVal){
      this.keywordCount = newVal.length
    }
  },
  mounted(){
    let count = 1;
    this.editableData[count] = {
        name: `${count}`,
        key:`${count}`,
        email: ``,
      };
      let that = this;
      getUserInfo().then(res=>{
        that.userId = res.user.userId
        getPlat(this.userId).then(res=>{
          res.data.map((cur,index)=>{
            that.plainOptions1.push({code:cur.dictValue,name:cur.dictLabel})
            that.plainOptions.push(cur.dictLabel)
          })
        })
      })
      console.log(this.editableData)
  },
  methods:{
    switchVal1(){
      let find = false;
      let arr = this.selectArr
      for (let i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
              if (arr[i] == arr[j]) { find = true; break;}
          }
          if (find) break;
      }
      if(find){
        message.error('目标关键词不可重复')
        return
      }
    },
    onCheckAllChange(e){
      Object.assign(this.state, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
      });
    },
    handleOpenChange(openStatus){
      this.open = openStatus
    },
    handleAdd(){
      let that = this
      const count = this.dataSource.length + 1
      const newData = {
        name: `${count}`,
        key:`${count}`,
        email: ``,
      };
      this.dataSource.push(newData);
      this.editableData[count] = {
        name: `${count}`,
        key:`${count}`,
        email: ``,
      };
    },
    cancel(key){
        delete this.editableData[key];
    },
    save(key){
      let that = this
        if(that.editableData[key].email==''){
          message.error('请输入邮箱')
          return
        }
       
        if(!(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(that.editableData[key].email))){
          message.error('邮箱格式不正确')
          return
        }
        let find = false;
        let arr = that.dataSource
        for (let i = 0; i < arr.length; i++) {
            // for (var j = i + 1; j < arr.length; j++) {
                if (arr[i].email == that.editableData[key].email) { find = true; break;}
            // }
            if (find) break;
        }
        if(find){
          message.error('该邮箱已添加')
          return
        }
          Object.assign(
            that.dataSource.filter((item) => key === item.key)[0],
            that.editableData[key]
          );
          delete that.editableData[key];
        // })
        // .catch((error) => {
        //   console.log('error', error);
        // });
    },
    edit(key){
      let that = this
      this.editableData[key] = cloneDeep(
        that.dataSource.filter((item) => key === item.key)[0]
      );
    },
    handleClose(){
      this.open = false;
      this.open2 = false;
    },
    qxreturn(){
        this.$router.push({ path: "/warningList" });
    },
    saveData(){
      let that=this;
      let dataStr = ''
      let canSubmit = true;
      let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
      this.dataSource.map((cur,index)=>{
        if(!reg.test(cur.email)){
          canSubmit = false;
        }
        dataStr = dataStr +','+ cur.email
      })
       dataStr = dataStr.substring(1,dataStr.length)
       if(this.YJname==''){
        message.info('预警名称不得为空')
        return
      }
      if(this.keyword==''){
        message.info('目标关键词不得为空')
        return
      }
      if(this.keyword.split(',').length>50){
        message.info('目标关键词数不得超出50个')
        return
      }
      if(this.times==''){
        message.info('预警频率不得为空')
        return
      }
      if(this.receiveDay==''){
        message.info('接收时段不得为空')
        return
      }
      if(this.receiveTimeStart==''){
        message.info('开始时间不得为空')
        return
      }
      if(this.receiveTimeEnd==''){
        message.info('结束时间不得为空')
        return
      }
      if(new Date('2020-10-10 '+this.getStr(this.receiveTimeEnd)).getTime()<=new Date('2020-10-10 '+this.getStr(this.receiveTimeStart)).getTime()){
        message.info('开始时间不得小于结束时间')
        return
      }
      if(this.state.checkedList.length==0){
        message.info('目标平台不得为空')
        return
      }
   
      if(this.dataSource.length==0){
        message.info('接收邮箱未填写')
        return
      }
      if(!canSubmit){
        message.info('接收邮箱格式不正确')
        return
      }
      let dataSource1 = {}
      if(this.kwBrandOpen){
        dataSource1 = {
          keywords:this.keyword,
          kwBrandCount:this.kwBrandCount,
          kwBrandOpen:this.kwBrandOpen,
          kwCount:this.kwCount,
          name:this.YJname,
          platforms:this.switchVal(this.state.checkedList),
          receiveDay:this.receiveDay,
          receiveEmail:dataStr,
          // times:1,
          times:this.times,
          receiveTimeBegin:this.getStr(this.receiveTimeStart),
          receiveTimeEnd:this.getStr(this.receiveTimeEnd),
        }
      }else{
        dataSource1 = {
            keywords:this.keyword,
            kwBrandOpen:this.kwBrandOpen,
            kwCount:this.kwCount,
            name:this.YJname,
            platforms:this.switchVal(this.state.checkedList),
            receiveDay:this.receiveDay,
            receiveEmail:dataStr,
            // times:1,
            times:this.times,
            receiveTimeBegin:this.getStr(this.receiveTimeStart),
            receiveTimeEnd:this.getStr(this.receiveTimeEnd),
          }
      }
      // console.log(dataSource1)
      this.loadingBtn = true;
      addyj(dataSource1).then(res=>{
        this.loadingBtn = false;
        if(res.code==200){
          this.$router.push("warningList")
        }
      })
    },
    onCreateYJ(){
      let count = 0;
      let that = this;
      this.state.checkedList.map((cur)=>{
        if(cur.indexOf('微博')!=-1){
          count++;
        }
      })
        if(count>1){
          Modal.confirm({
          title: '您选择了多个微博平台，请确认是否保存数据？',
          onOk() {
            that.saveData()
          },
          onCancel() {
          },
          });
        }else{
          that.saveData()
        }
     
      // if(choose){
      //   return
      // }
    },
    switchVal(val){
      let newArr = [];
      this.plainOptions1.map((cur,index)=>{
        val.map((cur1,index1)=>{
          if(cur1==cur.name){
            newArr.push(cur.code)
          }
        })
      })
      return newArr.join(',')
    },
    getStr(val){
      return new Date(val).getHours()<10?('0'+new Date(val).getHours()):(new Date(val).getHours()) + ':' +(new Date(val).getMinutes()<10?('0'+new Date(val).getMinutes()):new Date(val).getMinutes())+':'+(new Date(val).getSeconds()<10?('0'+new Date(val).getSeconds()):(new Date(val).getSeconds()))
    },
    returnsy() {
      this.$router.push({ path: "/warningList" });
    },
    onDelete(key){
      this.dataSource = this.dataSource.filter((item) => item.key !== key);
    },
    handleChange1(val){
      this.keyword = ''
      val.map((cur)=>{
        this.keyword = this.keyword+','+cur
      })
      this.keyword = this.keyword.substring(1,this.keyword.length)
    },
    getArr(){
      this.selectArr = this.keyword.split(',')
      this.selectArr = this.selectArr.filter(function (s) {
          return s && s.trim(); // 注：IE9(不包含IE9)以下的版本没有trim()方法
      });
      this.selectValue = this.selectArr
    }
  }
}
</script>

<style lang="scss" scoped>
.warninglogin {
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  .hoverBottomWapper{
    width: 100%;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
  /deep/.ant-breadcrumb-link{
    font-size: 14px;
  }
  .editable-add-btn{
    border-style: dashed;
  }
  .dataContent{
    background: #f0f2f5;
    padding: 24px;
    min-height: 280px;
    width: 82%;
    margin: 0 auto;
  }
  .headerContent{
    padding: 20px 84px 50px 84px;
    background-color: #fff;
    margin-bottom: 30px;
    .tip{
      font-weight: bold;
      font-size: 20px;
    }
    .ant-breadcrumb > span:last-child{
      color: rgba(0, 0, 0, 0.647058823529412);
    }
  }
  /deep/.bgCrumb{
    font-size: 22px;
    font-weight: bold;
  }
  /deep/.ant-breadcrumb-separator{
    font-size: 14px;
  }
  /deep/.ant-card{
    margin-bottom: 50px;
  }
  .ant-switch{
    margin-left: 20px;
  }
  // /deep/.ant-breadcrumb-link{
  //   font-size: 24px;
  // }
  /deep/.ant-form-inline .ant-form-item > .ant-form-item-control-wrapper, .ant-form-inline .ant-form-item > .ant-form-item-label{
    display: block;
    text-align: left;
  }
  .seting{
    font-weight: bold;
  }
}
.cur{
  cursor: pointer;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: black;
  height: 64px;
  width: 100%;
  margin-top: -60px;
  margin-bottom: 20px;
  .image-class {
    width: 170px;
    height: 75px;
    margin: auto 200px;
  }
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    & > span {
      color: rgb(218, 216, 216);
      margin-left: 20px;
      margin-right: 40px;
    }
  }
}
.form-class {
  display: flex;
  flex-direction: column;
}
.form-margin {
  margin: 25px 0;
}
</style>